import PropTypes from 'prop-types';
import Item from './Item';

import s from './styles.scss';

const Features = ({ homepage_features }) => (
  <div className={s.main}>
    {homepage_features &&
      homepage_features.length > 0 &&
      homepage_features.map((e, i) => (
        <Item
          key={`feauture${i}`}
          image={e.icon.url}
          title={e.title}
          desc={e.description}
        />
      ))}
  </div>
);

Features.propTypes = {
  homepage_features: PropTypes.array,
};

export default Features;
